import { z } from "zod";

export const registerSchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(2, "Vui lòng nhập họ tên.")
    .max(120, "Họ tên quá dài."),
  email: z.string().trim().toLowerCase().email("Email chưa hợp lệ."),
  password: z
    .string()
    .min(8, "Mật khẩu cần ít nhất 8 ký tự.")
    .max(72, "Mật khẩu tối đa 72 ký tự."),
  teachingGrade: z.coerce
    .number({ errorMap: () => ({ message: "Chọn khối lớp bạn đang dạy." }) })
    .int()
    .min(1)
    .max(5),
  acceptTerms: z.literal(true, {
    errorMap: () => ({ message: "Bạn cần đồng ý điều khoản sử dụng." }),
  }),
  /** Mã giới thiệu (tuỳ chọn) — từ link /moi/[code]. */
  ref: z.string().trim().max(20).optional(),
});

export const loginSchema = z.object({
  email: z.string().trim().toLowerCase().email("Email chưa hợp lệ."),
  password: z.string().min(1, "Vui lòng nhập mật khẩu."),
});

export type RegisterInput = z.infer<typeof registerSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
